import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
export var BadgePackageDiscount = function (_a) {
    var discountPercent = _a.discountPercent, className = _a.className;
    if (Long.ZERO.equals(discountPercent || 0)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: IdStyles.OfferBonusBlueBackground + " " + className },
        React.createElement("div", { className: "pb__small" },
            React.createElement(NumberFormat, { className: IdStyles.TextBoldSecondaryOutline, format: TypeNumberFormat.SignedPercent, amount: discountPercent }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/components/BadgePackageDiscount.tsx
// module id = 2959
// module chunks = 3